namespace GeniuzPOS.Lookups {
    export namespace VwCashierService {
        export const baseUrl = 'Lookups/VwCashier';

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<VwCashierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<VwCashierRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Retrieve = "Lookups/VwCashier/Retrieve",
            List = "Lookups/VwCashier/List"
        }

        [
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>VwCashierService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
